import { LogOut, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import { ADMIN_CARDS } from '@/config/adminCards';
import { ROUTE_PATHS } from '@/config/constants';
import { useAuth } from '@/contexts/AuthContext';
import { useFavoriteAdminCards } from '@/store/favoriteAdminCardsStore';

export function HeaderAdmin() {
  const { user, logout } = useAuth();
  const favorites = useFavoriteAdminCards((state) => state.favorites);
  const favoriteCards = ADMIN_CARDS.filter((card) =>
    favorites.includes(card.id),
  );

  return (
    <header className="bg-white shadow">
      <div className="container mx-auto flex items-center justify-between">
        <span className="text-gray-800">
          Hello,{' '}
          {user?.lastName
            ? `${user.firstName} ${user.lastName}`
            : user?.firstName}
          !
        </span>

        <nav className="px-6 py-3">
          <ul className="flex flex-wrap items-center gap-x-4 gap-y-1 whitespace-nowrap">
            <li>
              <Link
                to={ROUTE_PATHS.ADMIN_DASHBOARD}
                className="text-gray-800 hover:text-gray-600"
              >
                Dashboard
              </Link>
            </li>
            {favoriteCards.map((card) => (
              <li key={card.id}>
                <Link
                  to={card.actions[0].path}
                  className="text-gray-800 hover:text-gray-600"
                >
                  {card.menuLabel}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <Button
            type="button"
            variant="ghost"
            className="text-gray-800 hover:text-gray-600"
            asChild
          >
            <Link to={ROUTE_PATHS.ADMIN_SETTINGS}>
              <Settings className="mr-2 h-4 w-4" />
              Settings
            </Link>
          </Button>

          <Button
            asChild
            type="button"
            variant="ghost"
            className="text-gray-800 hover:text-gray-600"
            onClick={logout}
          >
            <Link to={ROUTE_PATHS.LOGOUT}>
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
